module.exports = __webpack_public_path__ + "static/media/Statua_032.fcd5b558.jpg";